import React from 'react';
import { datadogLogs } from '@datadog/browser-logs';
import { datadogRum } from '@datadog/browser-rum-slim';
import { useAuth } from '../context/auth/base';

export function DatadogGlobalScope() {
  const { authUser } = useAuth();

  React.useEffect(() => {
    if (!authUser) {
      datadogRum.removeUser();
      datadogLogs.clearUser();
      return;
    }

    const user = {
      id: authUser.id,
      email: authUser.email ?? undefined,
      publicAddress: authUser.publicAddress,
      artistId: authUser.artist?.id,
    };
    datadogRum.setUser(user);
    datadogLogs.setUser(user);
  }, [authUser]);

  return null;
}
